import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { SURVEY_SCREEN_NAME_OPTIONS } from '../../shared/models/list';
import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';
import { OfflineComponent } from '../../shared/components/offline/offline.component';
import { SurveyComponent } from '../../shared/components/survey/survey.component';
import { ScrollerDirective } from '../../shared/directives/scroller.directive';
import { AfterViewInitDirective } from '../../shared/directives/after-view-init.directive';

import {
	InformationOnDeliveryDateNewDesignComponent
} from './order-delivery/information-on-delivery-date-new-design.component';
import { AvailableBatchesComponent } from './order-delivery/available-batches.component';
import { MillsStockMaterialsComponent } from './order-delivery/mills-stock-materials.component';
import { DeliveryFollowUpComponent } from './order-delivery/delivery-follow-up.component';
import { InformationOnDeliveryDateComponent } from './order-delivery/information-on-delivery-date.component';

@Component({
	selector: 'copo-order-delivery',
	templateUrl: './order-delivery.component.html',
	imports: [
		AfterViewInitDirective,
		ScrollerDirective,
		NgIf,
		SurveyComponent,
		TranslateModule,
		InformationOnDeliveryDateComponent,
		DeliveryFollowUpComponent,
		MillsStockMaterialsComponent,
		AvailableBatchesComponent,
		OfflineComponent,
		InformationOnDeliveryDateNewDesignComponent
	]
})
export class OrderDeliveryComponent {
	isOffline: boolean;
	wotOverview: keyof typeof SURVEY_SCREEN_NAME_OPTIONS = 'orderdeliveryoverview';
	user: User;

	constructor(
		private readonly userService: UserService,
	) {
		this.isOffline = !navigator.onLine;
		this.user = this.userService.user;
	}
}
